var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import styled from "@emotion/styled";
import { Paper } from "@mui/material";
const bottomNavStyle = {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: "space-evenly",
    zIndex: 1,
};
const FooterWrapper = styled("div")(({ theme }) => {
    return {
        svg: {
            maxWidth: 50,
            maxHeight: 50,
            padding: 4,
        },
    };
});
export const BottomNavigationComponent = (props) => {
    var _a, _b;
    const rest = __rest(props, []);
    const [value, setValue] = React.useState(((_a = props === null || props === void 0 ? void 0 : props.navigationlist) === null || _a === void 0 ? void 0 : _a.selectedIndex) || 0);
    return (React.createElement(FooterWrapper, Object.assign({}, rest),
        React.createElement(Box, null,
            React.createElement(Paper, { elevation: 5 },
                React.createElement(BottomNavigation, { showLabels: true, value: value, sx: Object.assign(Object.assign({}, bottomNavStyle), props.style), onChange: (event, newValue) => {
                        var _a;
                        setValue(newValue);
                        (_a = props.navigationlist) === null || _a === void 0 ? void 0 : _a.bottomNavCallBack(newValue);
                    } }, (_b = props.navigationlist) === null || _b === void 0 ? void 0 : _b.bottomIconList.map((itemList, index) => {
                    return (React.createElement(BottomNavigationAction, { key: index, label: itemList === null || itemList === void 0 ? void 0 : itemList.label, icon: value === index ? itemList === null || itemList === void 0 ? void 0 : itemList.activeIcon : itemList === null || itemList === void 0 ? void 0 : itemList.icon, sx: Object.assign({}, props.style) }));
                }))))));
};
